import { render } from "./PricingMatrix.vue?vue&type=template&id=d2ed2ad6&scoped=true"
import script from "./PricingMatrix.vue?vue&type=script&lang=js"
export * from "./PricingMatrix.vue?vue&type=script&lang=js"

import "./PricingMatrix.vue?vue&type=style&index=0&id=d2ed2ad6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2ed2ad6"]])

export default __exports__